module.exports = __webpack_public_path__ + "static/media/blackMarker.50a2bb01.svg";